import React, { Component } from 'react';
import { View, Text } from 'react-native';
import { SHr, SImage, SText, SView, SNavigation, STheme } from 'servisofts-component2';
import SSocket from 'servisofts-socket';
import MDL from '../../MDL';

export default class UserProfile extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        return <SView center style={{
            position: "absolute",
            top: 8,
        }}>
            <SText bold fontSize={14}>MATRÍCULA</SText>

            <SView style={{
                width: 100,
                height: 35,
                borderRadius: 4,
                borderWidth: 1,
                borderColor: STheme.color.text,
                overflow: "hidden",
                backgroundColor: STheme.color.card
            }} center>
                <SText fontSize={14}>{`${MDL.usuario?.session?.plate}`}</SText>
            </SView>
            <SHr h={8} />
            <SText bold fontSize={14}>DNI {`${MDL.usuario?.session?.sDNI}`}</SText>
            <SText bold fontSize={14}>{`${MDL.usuario?.session?.sNombreChofer}`}</SText>
        </SView>

    }
}
